import React from 'react'
import { Chip, Tooltip } from '@material-ui/core'
import { styled } from '@material-ui/core/styles'

const StyledChip = styled(Chip)(({ theme, maxWidth = 200 }) => ({
  maxWidth: maxWidth,
  '& .MuiChip-label': {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
}))

/**
 * A reusable chip component that truncates long labels and shows full text in tooltip
 * @param {Object} props - Component props
 * @param {string} props.label - The label text to display
 * @param {number} props.maxWidth - Maximum width of the chip (default: 200px)
 * @param {boolean} props.showTooltip - Whether to show tooltip (default: true)
 * @param {React.ReactNode} props.icon - Icon to display
 * @param {string} props.variant - Chip variant ('default', 'outlined', 'filled')
 * @param {string} props.size - Chip size ('small', 'medium', 'large')
 * @param {Function} props.onDelete - Delete handler
 * @param {Object} props.sx - Additional styles
 * @param {Object} props.chipProps - Additional props to pass to the Chip component
 */
const TruncatedChip = ({
  label = '',
  maxWidth = 200,
  showTooltip = true,
  icon,
  variant = 'default',
  size = 'small',
  onDelete,
  sx = {},
  chipProps = {},
  ...otherProps
}) => {
  // Determine if we need a tooltip (if label is long or contains special characters)
  const needsTooltip = showTooltip && (label.length > 20 || label.includes('(') || label.includes(')'))

  const chip = (
    <StyledChip
      label={label}
      icon={icon}
      variant={variant}
      size={size}
      onDelete={onDelete}
      maxWidth={maxWidth}
      sx={sx}
      {...chipProps}
      {...otherProps}
    />
  )

  if (needsTooltip) {
    return (
      <Tooltip title={label} arrow placement="top">
        <span>{chip}</span>
      </Tooltip>
    )
  }

  return chip
}

export default TruncatedChip
